import { createFileRoute, redirect } from "@tanstack/react-router";

import { getItemSessionStorage } from "@/lib/utils";
import { ELocalStorageKeys } from "@/app/types/localStorage";

export const Route = createFileRoute("/")({
  beforeLoad: () => {
    const accessToken = getItemSessionStorage(ELocalStorageKeys.TOKEN);
    if (!accessToken) {
      throw redirect({ to: "/login" });
    } else {
      throw redirect({ to: "/dashboard" });
    }
  },
  component: IndexPage,
});

function IndexPage() {
  return <></>;
}
